import { useLocation } from 'react-router-dom';
import qs from "qs";
import Cookies from 'universal-cookie';
import backButton from '../libs/backButton';
import { useBreakpoint } from '../libs/breakpoint';
import { isBot } from '../libs/helper';
import userToken from './token';
import { useQuery } from '@tanstack/react-query';
import { apiUrl } from '../libs/api';
import { useState } from 'react';

const cookies = new Cookies();

const shouldBypassPopunder = () => {
    //
    // Si le navigateur est Chrome et que la langue <> FR ou que la page est traduite alors on bypass
    //
 
    // Chrome ?
    const userAgent = window.navigator.userAgent;
    const isChromiumBased = userAgent.indexOf("Chromium") > -1;
    const isChrome = !isChromiumBased && (userAgent.indexOf("Chrome") > -1 || userAgent.indexOf("CriOS") > -1);
 
    // FR ?
    let isFr = true;
    if ( !navigator.language && !navigator.userLanguage ) { // En principe on a l'un ou l'autre. Si ce n'est pas le cas c'est suspect => FALSE
        isFr = false;
    }
    else {
        if ( navigator.language && navigator.language.substring(0,2) !== 'fr' ) { // Si navigator.language existe mais n'est pas FR => FALSE
            isFr = false;
        }
        else if ( navigator.userLanguage && navigator.userLanguage.substring(0,2) !== 'fr' ) { // Si navigator.userLanguage existe mais n'est pas FR => FALSE
            isFr = false;
        }
        if ( navigator.languages && Array.isArray(navigator.languages) && navigator.languages.length && navigator.languages[0].substring(0,2) !== 'fr' ) { // Si navigator.languages existe mais que la première langue n'est pas FR
            isFr = false;
        }
    }
 
    const chromeTranslated = isChrome && !!document.querySelector('html.translated-ltr');
 
    return chromeTranslated || ( isChrome && !isFr );
}

const useDisclaimer = ({authorizedPaths}) => {
    const location = useLocation();
    const [token] = userToken();
    const { atoken } = qs.parse(location.search, { ignoreQueryPrefix: true });
    const [hasAcceptedDisclaimer, setHasAcceptedDisclaimer] = useState(cookies.get('DISCLAIMED') === 'accepted' || isBot || atoken || token);
    const authorizedPath = authorizedPaths.some(path => location.pathname.includes(path));

    const showDisclaimer = !hasAcceptedDisclaimer && !authorizedPath;
    const breakpoints = useBreakpoint();
    let source = localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_source`) || "";

    if (!hasAcceptedDisclaimer) {
        backButton("popdisclaimer", { source });
    }

    if (window.location.hash.match(/[#&](nodisclaimer)/)) {
        cookies.set('DISCLAIMED', 'accepted', { expire: 0 });
        let hash = window.location.hash.replace(/(.*)[#&]nodisclaimer(.*)/, '$1$2');
        if (hash !== "") {
            if (hash.substr(0, 1) === "&") {
                hash = hash.substr(1, hash.length);
            }
            if (hash.substr(0, 1) !== "#") {
                hash = `#${hash}`;
            }
        }
        let newUri = window.location.pathname + window.location.search + hash;
        window.history.replaceState({}, document.title, newUri);
    }

    const { data, isLoading, isError } = useQuery(
        ['fetchToolStatus'],
        () => apiUrl.post('/tools/istool', {
            userAgent: window.navigator.userAgent,
            language: window.navigator.language,
            platform: window.navigator.platform
        }, {
            timeout: 3000,
        }),
        {
            enabled: !hasAcceptedDisclaimer,
            retry: false,
        }
    );

    const initialized = !isLoading && !isError;

    const disclaim = () => {
        if(!initialized) return;
        localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_fromdsiclaimer`, "1");
        cookies.set('DISCLAIMED', 'accepted', { expire: 0 });

        const bypassPopUnder = shouldBypassPopunder() || !data?.status;

        if (bypassPopUnder) {
            setHasAcceptedDisclaimer(true);
            return;
        }

        window.open(window.location.href, '_blank');
        backButton("popunder");
        let uriTool = breakpoints.md ? "https://tools.emstat.fr/voissa/pop-mobile.php" : "https://tools.emstat.fr/voissa/pop-desktop.php";
        if (!["", "voissa"].includes(source)) {
            uriTool = `${uriTool}?adparameter2=${source}`;
        }
        window.open(uriTool, "_self");
    };

    return { loading: isLoading, status: !!data?.status, initialized , disclaim, hasAcceptedDisclaimer, showDisclaimer };
};


export default useDisclaimer;
